import { render, staticRenderFns } from "./ResourceCards.vue?vue&type=template&id=0941c5d7&"
import script from "./ResourceCards.vue?vue&type=script&lang=js&"
export * from "./ResourceCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports